export default __webpack_public_path__ + "static/culture-values-495e7105f5d7627670f78855502d6a67.png";